app.service("StyleService", ['$rootScope', 'AcquiredService',
    function ($rootScope, AcquiredService) {

        const siteHelper = $rootScope.site_helper;
        const modelConstructor = $rootScope.model_constructor;

        const StyleModel = modelConstructor.extend(AcquiredService.BasicAcquiredModel, {
            id: "style",
            name: "Style",
            request_range_id: null,
            site_range_id: null,
            valid_style_ids: [],
            isValidAcquiredObject: isValidAcquiredObject,
            applyItemHandler: applyItemHandler
        });

        let cachedStyles = {};

        function collectCachedStyles() {

            cachedStyles = {};

            const cacheLocalServerModel = $rootScope.model.cache_local_server;
            const siteRangeStyles = cacheLocalServerModel.style.site_range;
            if (!siteRangeStyles) {
                return
            }
            for (let siteRangeID in siteRangeStyles) {
                const styles = siteRangeStyles[siteRangeID].choices;
                const cachedSiteRange = cacheLocalServerModel.site_range[siteRangeID];
                const requestRangeID = cachedSiteRange ? cachedSiteRange.request_range_id : null;
                if (!cachedStyles[siteRangeID]) {
                    cachedStyles[siteRangeID] = {};
                }
                for (let styleID in styles) {
                    let cachedStyle = styles[styleID];
                    if (cachedStyle.id) {
                        cachedStyle = JSON.parse(JSON.stringify(cachedStyle));
                        cachedStyle.request_range_id = requestRangeID;
                        cachedStyle.tags = cachedStyle.tags ? cachedStyle.tags : [];
                        cachedStyles[siteRangeID][cachedStyle.id] = cachedStyle;
                        cachedStyle.colour_exceptions = cachedStyle.colour_exceptions ? siteHelper.arrayToObjectKeys(cachedStyle.colour_exceptions) : {};
                    }
                }
            }
        }

        this.factory = new modelConstructor.ModelFactory({
            birth: function (values) {
                return new StyleModel(values);
            },

            validVariationPointers: function (variationIDs) {
                return ['browse_id', 'solution_id', 'door_type_id', 'site_range_id', 'colour_id', 'assembly_id', 'component_id', 'base_component_id', 'parent_category_group_id', 'parent_category_id', 'alpha_category_id', 'product_id', 'custom_id'];
            },

            applyModelVariation: applyModelVariation
        });

        function isValidAcquiredObject(acquiredObject) {
            const model = this.root;
            const objectID = acquiredObject.id;

            return model.valid_style_ids.indexOf(objectID) !== -1;
        }


        function applyItemHandler(style) {

            const model = this.root;
            const variationIDs = model.variation_ids;

            const doorTypeID = model.variation_ids.door_type_id;
            var siteRangeID = variationIDs.site_range_id ? variationIDs.site_range_id : "bella";


            const cachedStyle = getCachedStyle(siteRangeID, style.id, doorTypeID)


            for (let key in cachedStyle) {
                let value = cachedStyle[key];
                if (siteHelper.isObject(value) || siteHelper.isArray(value)) {
                    value = JSON.parse(JSON.stringify(value));
                }
                style[key] = value;
            }

            style.disabled = !!style.disabled;
            style.disabled_temporarily = !!style.disabled_temporarily;


            const manufacturingProcessIDs = {};
            const baseStyleIDs = {};

            const cacheLocalServerModel = $rootScope.model.cache_local_server
            const baseStyleChoices = cacheLocalServerModel.base_style.choices;
            const manufacturingProcessChoices = cacheLocalServerModel.manufacturing_process.choices;

            for (let i = 0; i < style.tags.length; i++) {
                const tag = style.tags[i];
                if (baseStyleChoices[tag]) {
                    baseStyleIDs[tag] = true;
                }
                if (manufacturingProcessChoices[tag]) {
                    manufacturingProcessIDs[tag] = true;
                }
            }

            let imgSrc = style.img_src;

            if (!imgSrc && style.site_range_id !== "bella") {
                const siteRangeChoice = $rootScope.factory.site_range.choices[style.site_range_id];
                if (siteRangeChoice) {
                    imgSrc = siteRangeChoice.img_src;
                }
            }

            style.limited_stock = !!style.limited_stock || style.tags.indexOf("limited_stock") !== -1;
            style.promote_new = !!style.promote_new || style.tags.indexOf("promote_new") !== -1;
            style.coming_soon = !!style.coming_soon || style.tags.indexOf("coming_soon") !== -1;
            style.back_soon = !!style.back_soon || style.tags.indexOf("back_soon") !== -1;

            style.prominent_disabled = style.coming_soon || style.back_soon;


            siteHelper.applyValues(style, {
                manufacturing_process_ids: manufacturingProcessIDs,
                base_style_ids: baseStyleIDs,
                img_src: imgSrc,
                collectImageParams: function () {
                    const params = this.super();
                    params.image_type_id = "style";
                    params.site_range_id = model.site_range_id;
                    params.colour_id = $rootScope.navigation_model.state_ids.colour_id;
                    params.style_id = style.id;
                    return params;
                }
            });
        }

        function applyModelVariation(model) {

            this.super(model);

            let styleID;

            const variationIDs = model.variation_ids;

            const browseID = variationIDs.browse_id;
            const siteRangeID = variationIDs.site_range_id ? variationIDs.site_range_id : "bella";

            const requestRangeID = $rootScope.service.site_range.getRequestRangeID(siteRangeID);
            if (requestRangeID) {
                model.request_range_id = requestRangeID;
            }
            model.site_range_id = siteRangeID;


            const simulateAcquiredObjects = {};

            let styleExpected = true;
            if (browseID === "component") {
                if (siteRangeID === "bella") {
                    const componentObject = $rootScope.service.cache_local_server.getAnySiteRangeComponentObject(variationIDs.base_component_id, variationIDs.parent_category_group_id, variationIDs.parent_category_id, variationIDs.alpha_category_id);
                    if (componentObject && !componentObject.requires_style) {
                        styleExpected = false;
                    }
                } else {
                    styleExpected = false;
                }
            }
            const validStyleIDs = getValidStyleIDs(variationIDs, styleExpected);

            model.style_expected = styleExpected;
            model.valid_style_ids = validStyleIDs;

            model.request_endpoint = '/request/api.php/ranges/' + requestRangeID + '/styles';

            const siteRangeCachedStyles = cachedStyles[siteRangeID];
            if (siteRangeCachedStyles) {
                for (styleID in siteRangeCachedStyles) {
                    if (validStyleIDs.indexOf(styleID) !== -1) {
                        const cachedStyle = siteRangeCachedStyles[styleID];
                        simulateAcquiredObjects[cachedStyle.id] = JSON.parse(JSON.stringify(cachedStyle))
                    }
                }
            }


            model.buildAcquiredChoices(simulateAcquiredObjects);

            for (styleID in model.choices) {
                const style = model.choices[styleID];
                style.do_appear_disabled = true;
            }
        }

        function getCachedStyle(siteRangeID, styleID, doorTypeID) {
            const siteRangeCachedStyles = cachedStyles[siteRangeID];
            if (!siteRangeCachedStyles) {
                return {};
            }
            let cachedStyle = siteRangeCachedStyles[styleID];
            if (!cachedStyle) {
                return {};
            }
            if (!doorTypeID || !cachedStyle.door_type_state || !cachedStyle.door_type_state[doorTypeID]) {
                return cachedStyle;
            }
            cachedStyle = JSON.parse(JSON.stringify(cachedStyle));
            const doorTypeState = cachedStyle.door_type_state[doorTypeID]
            delete cachedStyle.door_type_state;
            for (let key in doorTypeState) {
                cachedStyle[key] = doorTypeState[key];
            }
            return cachedStyle;
        }

        function getValidStyleIDs(variationIDs, styleExpected) {

            const doorTypeID = variationIDs.door_type_id;
            const solutionID = variationIDs.solution_id;
            const siteRangeID = variationIDs.site_range_id ? variationIDs.site_range_id : "bella";
            const colourID = variationIDs.colour_id;
            const customID = variationIDs.custom_id;

            const baseComponentID = variationIDs.base_component_id;
            const parentCategoryGroupID = variationIDs.parent_category_group_id;
            const parentCategoryID = variationIDs.parent_category_id;
            const alphaCategoryID = variationIDs.alpha_category_id;
            const productID = variationIDs.product_id;

            let validStyleIDs = null;

            if (customID === "tallstor_drawer") {
                validStyleIDs = ["integra", "venice"];
            } else if (solutionID === "kitchen_inrail") {
                if (siteRangeID === "bella") {
                    validStyleIDs = ["richmond", "venice", "oakham"];
                }
            } else if (doorTypeID === "sliding") {
                if (siteRangeID === "bella") {
                    validStyleIDs = ["aldridge", "richmond", "venice"];
                }
            }

            function validateCachedStyle(cachedStyle) {
                if (!cachedStyle || cachedStyle.disabled || cachedStyle.disabled_temporarily) {
                    return false;
                }
                if (colourID) {
                    if (cachedStyle.colour_exceptions && cachedStyle.colour_exceptions[colourID]) {
                        return false;
                    }
                }
                return true;
            }

            let siteRangeCachedStyles = cachedStyles[siteRangeID];
            siteRangeCachedStyles = siteRangeCachedStyles ? siteRangeCachedStyles : {};
            if (validStyleIDs) {
                for (let i = 0; i < validStyleIDs.length; i++) {
                    if (!validateCachedStyle(getCachedStyle(siteRangeID, validStyleIDs[i], doorTypeID))) {
                        validStyleIDs.splice(i, 1);
                        i--;
                    }
                }
            } else {
                validStyleIDs = [];
                for (let styleID in siteRangeCachedStyles) {
                    if (validateCachedStyle(getCachedStyle(siteRangeID, styleID, doorTypeID))) {
                        validStyleIDs.push(styleID);
                    }
                }
            }

            const styleExceptions = $rootScope.service.cache_local_server.getStyleExceptions(
                siteRangeID,
                baseComponentID,
                parentCategoryGroupID,
                parentCategoryID,
                alphaCategoryID,
                productID
            );
            for (let i = 0; i < validStyleIDs.length; i++) {
                if (styleExceptions.includes(validStyleIDs[i])) {
                    validStyleIDs.splice(i, 1);
                    i--;
                }
            }
            if (!styleExpected && validStyleIDs.length) {
                if (validStyleIDs.length) {
                    validStyleIDs.length = 1;
                }
            }

            return validStyleIDs;
        }

        this.indexInit = function () {

            $rootScope.service.cache_local_server.requireInitialized(function () {
                collectCachedStyles();
            });
        }

    }])